import React from 'react';
import { Formik, Form } from 'formik';
import FormField from '../../components/FormField';
import Loader from '../../components/Loader';
import Button from 'react-bootstrap/Button';
import OrderHistory from './OrderHistory';
import Breadcrumb from '../../components/Breadcrumb';
import { isPossiblePhoneNumber } from 'libphonenumber-js';

import { connect } from 'react-redux';
import { updateProfile } from '../../redux/User';
const mapStateToProps = state => {
    return {
        userData: state.user.data.actingAsUser == null ? state.user.data : state.user.data.actingAsUser,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        updateProfile: (d,c,e) => { dispatch(updateProfile(d,c,e)); }
    }
}

const AccountRow = (props) => {
    return (
        <div className="row mb-2">
            <div className="col-auto col-sm-3 col-lg-2">{props.label}:</div>
            <div className="col">{props.children}</div>
        </div>
    );
}

class Account extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            serverError: false
        }
    }

    componentDidMount() {
        setTimeout(() => {window.scrollTo(0, 0);}, 100);
    }

    validateDetails = (values) => {
        let errors = {};
        if (!values.email || values.email === "") {
            errors.email = "Please enter your email";
        }
        if (!values.accountName || values.accountName === "") {
            errors.accountName = "Please enter your Account Name";
        }
        if (!values.firstName || values.firstName === "") {
            errors.firstName = "Please enter your First Name";
        }
        if (!values.lastName || values.lastName === "") {
            errors.lastName = "Please enter your Last Name";
        }
        if (values.password && values.password !== "" && (!values.confirmPassword || values.password !== values.confirmPassword)) {
            errors.confirmPassword = "Password must match";
        }
        if (values.phone && values.phone !== "") {
            const {userData} = this.props;
            let c = userData.country && userData.country.toLowerCase() === "nz" ? "NZ" : "AU";
            let p = isPossiblePhoneNumber(values.phone, c);
            if (!p) {
                errors.phone = "Please enter a valid phone number";
            }
        }
        return errors;
    }

    submitDetails = (values, formikBag) => {
        this.props.updateProfile(
            values,
            () => {
                formikBag.setSubmitting(false);
                this.setState({editing: false});
            },
            (error) => {
                let msg = "An error has occured";
                if (error.body && error.body.message) {
                    msg = error.body.message;
                }
                if (error.body && error.body.modelState) {
                    formikBag.setErrors(error.body.modelState);
                } else if (error.status === 409) {
                    formikBag.setErrors({email: "The email address is already in use"});
                }
                formikBag.setSubmitting(false);
                this.setState({serverError: msg});
            }
        )
    }

    render() {
        const {userData} = this.props;
        return (
          <div className="page mb-5 account container px-3 px-md-5">
                <Breadcrumb>Account</Breadcrumb>
                <h1 className="mb-5">Account</h1>
                <h3 className="mb-3">Details</h3>

                {this.state.editing &&
                    <Formik
                        validate={this.validateDetails}
                        onSubmit={this.submitDetails}
                        initialValues={{
                            accountName: userData.accountName,
                            companyName: userData.companyName,
                            firstName: userData.firstName,
                            lastName: userData.lastName,
                            email: userData.email,
                            phone: userData.phone
                        }}
                    >
                        {(formikBag) => (
                            <Form className="position-relative">
                                {formikBag.isSubmitting && <Loader />}
                                <FormField id="accountName" label="Account name" formikBag={formikBag} hasValidation />
                                <FormField id="companyName" label="Company name" formikBag={formikBag} />
                                <FormField id="firstName" label="First name" formikBag={formikBag} hasValidation />
                                <FormField id="lastName" label="Last name" formikBag={formikBag} hasValidation />
                                <FormField id="email" label="Email" formikBag={formikBag} hasValidation />
                                <FormField id="phone" label="Phone" formikBag={formikBag} />
                                <FormField id="password" label="New password" type="password" autoComplete="new-password" formikBag={formikBag} />
                                <FormField id="confirmPassword" label="Confirm new password" type="password" autoComplete="new-password" formikBag={formikBag} hasValidation />
                                {this.state.serverError && <p className="server-error text-danger py-3">{this.state.serverError}</p>}
                                <div className="text-end mt-5">
                                    <Button type="button" variant="outline-primary" onClick={() => { this.setState({editing: false, serverError: false}); }} className="me-2">Cancel</Button>
                                    <Button type="submit" variant="primary">Save</Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                }

                {!this.state.editing && <>
                    <AccountRow label="Account ID">{userData.accountId}</AccountRow>
                    <AccountRow label="Account name">{userData.accountName}</AccountRow>
                    <AccountRow label="Company name">{userData.companyName}</AccountRow>
                    <AccountRow label="First name">{userData.firstName}</AccountRow>
                    <AccountRow label="Last name">{userData.lastName}</AccountRow>
                    <AccountRow label="Email">{userData.email}</AccountRow>
                    <AccountRow label="Phone">{userData.phone}</AccountRow>
                    <AccountRow label="Country">{userData.country}</AccountRow>
                    <p className="mt-5"><Button variant="primary" onClick={() => { this.setState({ editing: true }); }}>Edit my details</Button></p>
                </>}

                <hr className="my-5" />

                <OrderHistory thisUser={userData.actingAsUser ? userData.actingAsUser.accountId : userData.accountId} />

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account);
